import { useMemo } from "react";
import {
  functionalUpdate,
  OnChangeFn,
  SortingState,
} from "@tanstack/react-table";
import { useSearchParams } from "react-router-dom";

import { ORDER } from "~/common/constants";
import { PATIENT_FILTER_PARAMS } from "~/providers/constants/patients";
import {
  getColumnIdFromOrderBy,
  getOrderByFromColumnId,
} from "./patientSearchTableSorting";

export const usePatientSearchTableSorting = () => {
  const [params, setParams] = useSearchParams();

  const sorting = useMemo((): SortingState => {
    const order = params.get(PATIENT_FILTER_PARAMS.order);
    const orderBy = params.get(PATIENT_FILTER_PARAMS.orderBy);

    if (!order || !orderBy) return [];

    const columnId = getColumnIdFromOrderBy(orderBy);
    if (!columnId) return [];

    return [{ id: columnId, desc: order === ORDER.descendant }];
  }, [params]);

  const onSortingChange: OnChangeFn<SortingState> = (updater) => {
    const newSorting = functionalUpdate(updater, sorting);
    const newParams = new URLSearchParams(params);

    newParams.delete(PATIENT_FILTER_PARAMS.page);

    if (newSorting.length === 0) {
      newParams.delete(PATIENT_FILTER_PARAMS.order);
      newParams.delete(PATIENT_FILTER_PARAMS.orderBy);
    } else {
      const { id, desc } = newSorting[0];
      const orderBy = getOrderByFromColumnId(id);

      if (!orderBy) return;

      newParams.set(
        PATIENT_FILTER_PARAMS.order,
        desc ? ORDER.descendant : ORDER.ascendant,
      );
      newParams.set(PATIENT_FILTER_PARAMS.orderBy, orderBy);
    }

    setParams(newParams);
  };

  return { sorting, onSortingChange };
};
